import { render } from "./TierraBrava.vue?vue&type=template&id=2d04db7c"
import script from "./TierraBrava.vue?vue&type=script&lang=js"
export * from "./TierraBrava.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__